import { render } from "./ShowPresentation.vue?vue&type=template&id=1824a056&scoped=true"
import script from "./ShowPresentation.vue?vue&type=script&lang=js"
export * from "./ShowPresentation.vue?vue&type=script&lang=js"

import "./ShowPresentation.vue?vue&type=style&index=0&id=1824a056&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1824a056"]])

export default __exports__